import * as React from 'react';

interface Props {
	email: string;
}

const DeleteEmailBody: React.FC<Props> = (props) => {

	const {
		email,
	} = props;

	return (
		<>
			You are about to delete email contact <b>{email}</b>.
			Are you sure you want to continue?
		</>
	);
};

export default React.memo(DeleteEmailBody);
